import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useToast } from 'components/ui/use-toast';
import * as Api from '../api';
import * as Types from '../types';

const useSubmit = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: async (data: Types.IMutation.Submit) => {
      const response = await Api.Submit(data.attemptId);
      return response.data;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['attempt', 'single', variables.attemptId] });
      queryClient.invalidateQueries({ queryKey: ['attempt', 'byTest'] });
      toast.success(t('success'), {
        description: t('test_submitted_successfully', 'Your test has been submitted successfully'),
      });
    },
    onError: (error: any) => {
      toast.error(t('error'), {
        description:
          error?.response?.data?.message || t('failed_to_submit_test', 'Failed to submit the test'),
      });
    },
  });
};

export default useSubmit;
